<template>
  <div>
    <stock-header></stock-header>
    <div class="container">
      <el-row :gutter="10">
        <el-col :span="18">
          <stock-rise></stock-rise>
        </el-col>
        <el-col :span="6">
          <stock-card></stock-card>
        </el-col>
        
      </el-row>
    </div>
  </div>
</template>
<script>
import StockHeader from "@/components/stockheader";

import StockCard from "@/components/stockcard"
import StockRise from "@/components/stockrise"
export default {
  name: "stockmarket",
  components: {
    StockHeader,
    StockCard,
    StockRise
  },
  data() {
    return {
    };
  },
  methods: {

  },
  mounted: function () {
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1000px;
  margin: 10px auto;
}
</style>





// WEBPACK FOOTER //
// src/components/stockmarket.vue